import React from "react";
import Table from "../../../components/table.jsx";
import { ArrowCircleDown2, ArrowCircleUp2 } from "iconsax-react";

const AdminCertificationDetailsTable = ({
  columns,
  filteredData,
  isMobile,
  handleDownloadData,
  handleDownloadCertificates,
  selectedRows,
  enableDownloadCertificates,
  pageChangeHandler,
  totalData,
  currentPage,
  totalRecords,
}) => {
  // Calculate how many selected rows are actually in the current page data
  const selectedRowsInCurrentPage = filteredData.filter((item) => {
    const uniqueId = item._original?.developer_certificate_id || `${item.email}-${item.txn_id}`;
    return selectedRows.has(uniqueId);
  }).length;

  return filteredData.length > 0 ? (
    <div 
      className="table-container"
      style={{ 
        overflowX: isMobile ? "auto" : "visible",
        marginBottom: isMobile ? "20px" : undefined,
        WebkitOverflowScrolling: isMobile ? "touch" : undefined
      }}
    >
      <div className="bg-white rounded-lg shadow-lg overflow-hidden">
        {/* Header Section */}
        <div className="flex items-center px-6 py-4 border-b border-gray-200">
          <div className="flex items-center gap-4">
            <span className="text-xl font-bold text-gray-700">Total Records: {totalRecords}</span>
          </div>
          <div className="flex-1 flex justify-center">
            <h2 className="text-xl font-bold text-gray-700">Certificate Details</h2>
          </div>
          <div className="flex items-center gap-4">
            {/* Download Buttons */}
            <div className="flex items-center gap-2">
              <span className="text-gray-700 text-sm font-medium">Download Data</span>
              <button
                onClick={handleDownloadData}
                className="flex items-center justify-center p-2 text-gray-600 hover:text-gray-800 focus:outline-none"
                style={{
                  minHeight: "40px",
                  minWidth: "40px",
                }}
                title="Download Excel Data"
              >
                <ArrowCircleDown2 className="w-5 h-5" />
              </button>
            </div>
            <div className="flex items-center gap-2">
              <span
                className={`text-sm font-medium ${
                  enableDownloadCertificates ? "text-gray-700" : "text-gray-300"
                }`}
              >
                Download Certificate(s)
              </span>
              <button
                onClick={enableDownloadCertificates ? handleDownloadCertificates : undefined}
                disabled={!enableDownloadCertificates}
                className={`flex items-center justify-center p-2 focus:outline-none ${
                  enableDownloadCertificates
                    ? "text-gray-600 hover:text-gray-800"
                    : "text-gray-300 cursor-not-allowed"
                }`}
                style={{
                  minHeight: "40px",
                  minWidth: "40px",
                }}
                title={
                  enableDownloadCertificates
                    ? (selectedRowsInCurrentPage > 0
                        ? `Download ${selectedRowsInCurrentPage} Certificate(s) from current page`
                        : "Download all certificates")
                    : "Certificates available only in Certified tab"
                }
              >
                <ArrowCircleDown2 className="w-5 h-5" />
              </button>
            </div>
          </div>
        </div>
        {/* Table Content */}
        <Table
          columns={columns}
          data={filteredData}
          title=""
          hasSearch={false}
          filters={columns.map((column) => column.accessor).filter(Boolean)}
          pageChangeHandler={pageChangeHandler}
          totalData={totalData}
          currentPage={currentPage}
        />
      </div>
    </div>
  ) : null;
};

export default AdminCertificationDetailsTable;